import CustomTheme from './CustomTheme';

export default CustomTheme;